import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import { FormPreview } from 'modules/forms'
import { QuestionnaireResponse } from 'modules/questionnaires/components/QuestionnaireResponse'
import { QuestionnaireResponseContent } from 'modules/questionnaires/lib/types'

type Props = {
  open: boolean
  onClose: () => void
  currentPreview: QuestionnaireResponseContent
}
export const PreviewSidepanel = ({ open, onClose, currentPreview }: Props) => {
  const orphan = false
  return (
    <Sidepanel
      open={open}
      title={i18n.t('trainings.surveys.create.preview_title')}
      onClose={onClose}
      headerBorder
      width="wideXL"
    >
      <QuestionnaireResponse readonly content={currentPreview} onAnswer={() => ({})} />
      {/* Next line is here only to prevent the orphan 'src/modules/index.ts' */}
      {orphan && (
        <FormPreview
          resourceType="Trainings::Training"
          resourceId={'1'}
          isOpen={open}
          onClose={onClose}
          formId={'60'}
        />
      )}
    </Sidepanel>
  )
}
